export const giftListUrl = "#";
export const helpListUrl = "#";
export const facebookGroupUrl = "#";
export const instagramUrl = "#";
export const googleMapsUrl = "https://goo.gl/maps/rtTv6HzfZrP6L8xi6";
